var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.447,
    height: 23.427,
    viewBox: "0 0 18.447 23.427",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Task_selected",
    "data-name": "Task selected",
    transform: "translate(-3.47 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16758",
    "data-name": "Group 16758",
    transform: "translate(3.569)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10251",
    "data-name": "Path 10251",
    d: "M31.274,0c.909.519,1.063.714,1.249,1.618.156.01.327.031.5.031,1.1,0,2.2,0,3.3,0a2.563,2.563,0,0,1,2.832,2.855q0,3.684,0,7.368,0,4.273,0,8.547a2.547,2.547,0,0,1-2.819,2.8q-6.307,0-12.614,0a2.547,2.547,0,0,1-2.813-2.808q0-8.016,0-16.032a2.537,2.537,0,0,1,2.716-2.731c1.292-.008,2.585,0,3.91,0A1.919,1.919,0,0,1,28.8,0ZM27.552,3.306c-1.332,0-2.569,0-3.807,0-.936,0-1.194.255-1.194,1.179q0,7.93,0,15.861c0,1,.242,1.236,1.26,1.236H36.192c1.11,0,1.324-.219,1.325-1.355q0-7.783,0-15.566c0-.2.066-.441-.026-.579-.19-.286-.456-.719-.709-.732-1.405-.071-2.815-.034-4.3-.034v1.6H27.552Zm3.293-1.625H29.209V3.286h1.636Z",
    transform: "translate(-20.906)",
    fill: "#427be0",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10253",
    "data-name": "Path 10253",
    d: "M52.175,68.283l1.076-1.009,2.169,2.267,4-4.014,1.117,1.209-4.956,4.992-3.408-3.445",
    transform: "translate(-47.215 -55.134)",
    fill: "#427be0",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskselected);
export default __webpack_public_path__ + "static/media/Task selected.d906c4ccad915315cdeeaac9ffee5c60.svg";
export { ForwardRef as ReactComponent };